export default __webpack_public_path__ + "static/media/SalesTargets_Store.44d3ffc7.png";